export default __webpack_public_path__ + "b2fb46890f1bd89d38279e521e832f78.svg";